module.exports = __webpack_public_path__ + "static/media/more.0c047b25.svg";